import { useEffect, useRef } from 'react'
import { IntegrationServices } from '@sequencehq/api'
import { useConnectedIntegrationCustomers } from 'Customers/utils/useConnectedIntegrationCustomers'

type ConnectedIntegration = NonNullable<
  ReturnType<typeof useConnectedIntegrationCustomers>['integrations']
>[number]

export const useIntegrationSelectionDefaults = (params: {
  integrations: ConnectedIntegration[] | undefined
  isReady: boolean
  selectedIntegration: IntegrationServices | null
  onSelect: (service: IntegrationServices) => void
  onSkip: () => void
}) => {
  const { integrations, isReady, selectedIntegration, onSelect, onSkip } =
    params
  const hasSkipped = useRef(false)

  useEffect(() => {
    if (!isReady || !integrations?.length) {
      return
    }
    const defaultIntegration =
      integrations.find(hasCustomersToImport) ?? integrations.at(0)
    if (!defaultIntegration) {
      return
    }
    if (!selectedIntegration) {
      onSelect(defaultIntegration.service)
    }
    if (integrations.length === 1 && !hasSkipped.current) {
      hasSkipped.current = true
      onSkip()
    }
  }, [integrations, isReady, selectedIntegration, onSelect, onSkip])
}

const hasCustomersToImport = (integration: ConnectedIntegration) =>
  integration.totalLinkedCustomers !== integration.totalCustomers
